export const filtrosNube = {
	pais: ['México', 'Chile', 'Argentina', 'Canadá', 'Costa Rica', 'Australia', 'Colombia'],
	etapa: [
		'Activación de la justicia',
		'Procesamiento digital de los conflictos',
		'Formulación y ejecución de los fallos judiciales con apoyo tecnológico'
	] 
}